import type { Theme } from '@mui/material';

import type { CodingResult } from 'src/types/dashboard';

export const styles = {
  legendTopicButton: (topic: CodingResult) => (theme: Theme) => ({
    backgroundColor: theme.colors.neutral[50],
    borderColor: theme.colors.neutral[50],
    color: theme.colors.black,
    fontWeight: theme.typography.fontWeightSemiBold,
    justifyContent: 'left',

    '&.MuiToggleButton-root': {
      minHeight: '1.25rem',
      py: 0,
      px: 0.5,
      mt: 0,
      mb: 1.5,
      border: 0,
      borderRadius: '0.25rem',
    },

    '&:hover, &.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: topic.color,
      borderColor: topic.color,
      color: topic.secondaryColor,

      '&:before': {
        content: '" "',
        display: 'inline-block',
        left: '-1rem',
        position: 'absolute',
        backgroundColor: topic.color,
        borderRadius: '50%',
        height: '0.5rem',
        width: '0.5rem',
      },
    },

    [theme.breakpoints.up('sm')]: {
      width: '100%',
    },
  }),
};
